import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72deabd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Login connection" }
const _hoisted_2 = { class: "connection__left" }
const _hoisted_3 = { class: "connection__right" }
const _hoisted_4 = { class: "connection__content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["type"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "connection__footer" }
const _hoisted_13 = { class: "connection__menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_ButtonClose = _resolveComponent("ButtonClose")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ButtonSave = _resolveComponent("ButtonSave")!
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_LayoutConnected = _resolveComponent("LayoutConnected")!

  return (_openBlock(), _createBlock(_component_LayoutConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AppearObject, { class: "connection__background" }, {
            default: _withCtx(() => [
              _createVNode(_component_LazyPicture, {
                image: { url: '/images/connection/login.jpg', double: {url: '/images/connection/login@2x.jpg' }},
                class: "picture picture--full",
                lazy: false
              }, null, 8, ["image"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("header", null, [
            _createVNode(_component_ButtonClose, {
              class: "connection__close",
              to: "/",
              variant: "dark"
            }),
            _createVNode(_component_Logo, { class: "connection__logo" })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AppearObject, null, {
              default: _withCtx(() => [
                _createElementVNode("h1", null, [
                  _createVNode(_component_LineByLine, {
                    innerHTML: _ctx.$t('login.title')
                  }, null, 8, ["innerHTML"])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("form", {
              class: "connection__form form",
              onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, [
              _createElementVNode("p", {
                class: "connection__instructions",
                innerHTML: _ctx.$t('login.instructions')
              }, null, 8, _hoisted_5),
              _createElementVNode("fieldset", null, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.$t('login.email')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  name: "email",
                  required: "",
                  autocomplete: "off",
                  spellcheck: "false",
                  autocapitalize: "off",
                  autocorrect: "off",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.$t('login.password')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: _ctx.isPasswordObscurated ? 'password' : 'text',
                  name: "password",
                  required: "",
                  autocomplete: "off",
                  spellcheck: "false",
                  autocapitalize: "off",
                  autocorrect: "off",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                }, null, 8, _hoisted_6), [
                  [_vModelDynamic, _ctx.password]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass({ 'form__hide': true, 'active': _ctx.isPasswordObscurated }),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPasswordObscurated = !_ctx.isPasswordObscurated)),
                  tabindex: "-1"
                }, _hoisted_9, 2)
              ]),
              (_ctx.error === 'badcredentials')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "connection__error",
                    innerHTML: _ctx.$t('error.badcredentials')
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.error === 'default')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "connection__error",
                    innerHTML: _ctx.$t('error.default')
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_router_link, { to: "/register" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('login.register')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/forgot-password" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('login.forgot')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_ButtonSave, {
                  type: "submit",
                  class: "button",
                  loading: _ctx.isLoading
                }, {
                  saved: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.logged')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.action')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)
          ])
        ]),
        _createVNode(_component_BackButton, {
          class: "connection__back",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('login.back')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}